import React, { useState } from "react";
import styled from "styled-components";

import { MagnifierIcon } from "assets/icons";
import { TextInput } from "ui/components/styled/formControls";

const Wrapper = styled.div`
  position: relative;
`;

export const StyledInput = styled(TextInput)`
  width: 100%;

  input {
    width: 100%;
    padding-left: 16px;
    padding-right: 30px;
  }
  button {
    right: 32px;
  }
`;

const SearchIcon = styled(MagnifierIcon)`
  position: absolute;
  right: 12px;
  bottom: 18px;
  transform: translateY(50%);
  pointer-events: none;
  color: ${(p) => p.theme.textLowContrast};
`;

interface SearchInputProps {
  id: string;
  className?: string;
  label: string;
  labelVisible?: boolean;
  placeholder?: string;
  value?: string;
  onChange: (value?: string) => void;
  onBlur?: (value?: string) => void;
}
export const SearchInput: React.FC<SearchInputProps> = (props) => {
  const { className, value, onChange, placeholder, ...other } = props;
  const [val, setValue] = useState<string | undefined>(value);

  const handleChange = (_value?: string) => {
    setValue(_value);
    onChange(_value);
  };

  return (
    <Wrapper className={className}>
      <StyledInput
        {...other}
        autoComplete="off"
        clearable={true}
        value={val}
        placeholder={placeholder || "Type search phrase..."}
        onChange={handleChange}
      />
      <SearchIcon />
    </Wrapper>
  );
};
